export default {
  rowStyle: 'flex items-center',
  textLarge: 'text-base! font-normal! leading-2!',
  text: 'text-xs! font-normal!',
};
